import { render, staticRenderFns } from "./sku.vue?vue&type=template&id=d79d1140&scoped=true"
import script from "./sku.vue?vue&type=script&lang=js"
export * from "./sku.vue?vue&type=script&lang=js"
import style0 from "./sku.vue?vue&type=style&index=0&id=d79d1140&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79d1140",
  null
  
)

export default component.exports